import { render, staticRenderFns } from "./placard_rejection_poup.vue?vue&type=template&id=a37b908a&scoped=true"
import script from "./placard_rejection_poup.vue?vue&type=script&lang=js"
export * from "./placard_rejection_poup.vue?vue&type=script&lang=js"
import style0 from "./placard_rejection_poup.vue?vue&type=style&index=0&id=a37b908a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37b908a",
  null
  
)

export default component.exports